export const SET_SETTINGS = 'FINANCIAL_CONTROL/SET_SETTINGS'
